/**
 * Confirmation de suppression avec saisie obligatoire de la raison : l'élément
 * part à la corbeille, la raison y est affichée aux administrateurs.
 */
export default class ConfirmSuppression {
    /** Longueur maximale acceptée par l'API (règle `max:1000`). */
    static readonly RAISON_MAX_LENGTH: number = 1000;

    /**
     * Résout avec la raison saisie, ou `null` si l'utilisateur annule
     * (sweetalert rejette alors sa promesse).
     */
    static demanderRaison(
        titre: string,
        texte?: string
    ): Promise<string | null> {
        // @ts-ignore
        return swal({
            title: titre,
            text: texte || "",
            type: "warning",
            input: "textarea",
            inputPlaceholder: "Raison de la suppression",
            inputAttributes: {
                maxlength: ConfirmSuppression.RAISON_MAX_LENGTH,
            },
            // sweetalert2 v4 : l'erreur s'affiche sur un rejet, une promesse
            // résolue valide la saisie quelle que soit sa valeur.
            inputValidator: function (value: string) {
                return new Promise(function (resolve, reject) {
                    if (String(value || "").trim()) {
                        resolve();
                    } else {
                        reject("La raison est obligatoire.");
                    }
                });
            },
            // Un clic sur le fond ne doit pas faire perdre le texte saisi
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonClass: "btn btn-danger",
            confirmButtonText: "Supprimer",
            cancelButtonClass: "btn btn-default",
            cancelButtonText: "Annuler",
            buttonsStyling: false,
        }).then(
            function (raison: string) {
                return String(raison).trim();
            },
            function () {
                return null;
            }
        );
    }
}
